module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAOBJREFUWAntlbENwjAQRe8sVmAGpggGUZGeGRiAOdLDHIh0KAkVK7ABC9D6c4bu7EgukJCiS3f/7Ny/J0ufyD4jYASMwEQIcMkew9AdCKhLziZnmFvv102iK2Gm6nz5NfEk5ps+gBAax+4Mpl73KKCSBbai/8hInCAmZLOTHtZ31yMQHn61SXpCksTMTt/J1S4n/kMzI5q6ETEimoCu7Y0YEU1A12WhF28By092qD9I6L2Y3UJ6e9WKOVMl2ohQZAREFwbVYiYJMCa+A5gTKOnFmZLK7chsk42AETAC0yTwBifbPo7eZ7SRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/icon_shuju.png
// module id = pAmw
// module chunks = 1